// extracted by mini-css-extract-plugin
module.exports = {"bgPreloader":"Preloader_bgPreloader__N1GD3"};